import { BOOKING_INTENTION_VERIFY } from "../../../utils/endpoints";

export const stageOptions = [
  { value: 'الروضة', label: 'الروضة' },
  { value: 'الابتدائي', label: 'الابتدائي' },
  { value: 'المتوسط', label: 'المتوسط' },
  { value: 'الثانوي', label: 'الثانوي' },
  { value: 'الجامعة', label: 'الجامعة' },
];

export const subjectOptions = [
  { value: 'الانجليزي', label: 'الانجليزي' },
  { value: 'الرياضيات', label: 'الرياضيات' },
  { value: 'الفيزياء', label: 'الفيزياء' },
  { value: 'الكيمياء', label: 'الكيمياء' },
  { value: 'القدرات', label: 'القدرات' },
  { value: 'التحصيلي', label: 'التحصيلي' },
  { value: 'المتابعة', label: 'المتابعة' },
  { value: 'أخرى', label: 'أخرى' },
];

export const theme = {
  colors: {
    primary: '#eee',
    neutral0: '#fff',
    neutral5: '#fff',
    neutral10: '#eee',
    neutral20: '#a5a5a5',
    neutral30: '#ff693d',
    neutral40: '#ff693d',
    neutral50: '#888',
    neutral60: '#000',
    neutral70: '#ff693d',
    neutral80: '#000',
    neutral90: '#000',
  },
};

export async function sendCode(data) {
  try {
    const res = await fetch(BOOKING_INTENTION_VERIFY, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Internal-Token': process.env.NEXT_PUBLIC_INTERNAL_API_KEY,
      },
      body: JSON.stringify(data),
    });
    
    if (!res.ok) {
      const errorData = await res.json();
      return {
        status: false,
        message: errorData.message || 'حدث خطأ أثناء إرسال الرمز',
        error: errorData.error
      };
    }
    const json = await res.json();
    
    return json;
  } catch (error) {
    console.error("Error sending verification code:", error);
    return {
      status: false,
      message: 'حدث خطأ في الاتصال بالخادم',
      error: error.message
    };
  }
}